export default {"src":"/login-app/[GIT_HASH]/_next/static/media/concept_book.ccf92987.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};